import React from "react";

import Html from "./Html";
import { Provider } from "./Provider";

const PendingApplication = () => {
    return(
        <Provider>
            <Html/>
        </Provider>
    )
} 

export default PendingApplication;